module.exports = __webpack_public_path__ + "img/projek-sppik.05e72bba.png";